import React from 'react';

import Button from 'components/Button';

import './styles.css';

const SubmitButton = ({submitting, triggerSubmit}) => {
  return (
    <div className="SubmitButton">
      <Button
        blue={!submitting}
        isLoading={submitting}
        disabled={submitting}
        onClick={triggerSubmit}>
        Add employment
      </Button>
    </div>
  );
};

export default SubmitButton;
